import React, { useState } from 'react';
import { Row } from 'antd';
import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import moment from 'moment';

import API from 'helpers/API';
import ByChargeStatus from 'pages/dashboard/tanks/ByChargeStatus';
import ByExpireDate from 'pages/dashboard/tanks/ByExpireDate';
import ByInspectionDate from 'pages/dashboard/tanks/ByInspectionDate';
import ByUseStatus from 'pages/dashboard/tanks/ByUseStatus';

import styles from '../../dashboard/tanks/index.module.scss';

const cx = classNames.bind(styles);

const Page = () => {
  const [tanks, setTanks] = useState();

  const queryTanks = () => {
    API.get('/customer/tanks/status').then(({ success, data }) => {
      if (success) {
        setTanks(data.tanks ?? []);
      }
    });
  };

  useMountEffect(() => {
    queryTanks();
  });

  return (
    <div className={cx('container')}>
      <p className={cx('time')}>{moment().format('YYYY년 M월 D일 HH:mm 기준')}</p>

      <Row className={cx('wrapper')}>
        <ByUseStatus data={tanks} />
        <ByChargeStatus data={tanks} />
        <ByExpireDate data={tanks} enableNavigation={false} />
        <ByInspectionDate data={tanks} enableNavigation={false} />
      </Row>
    </div>
  );
};

export default Page;
